export const HTTP_ERROR_MESSAGE =
    'Возможно, есть проблемы с сетью. Попробуйте перезагрузить страницу и повторить попытку.'
